import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-8 py-2 pt-2" }
const _hoisted_2 = { class: "flex justify-between md:justify-start items-center gap-2 lg:gap-10" }
const _hoisted_3 = { class: "font-bold text-lg py-4 flex gap-3 items-center" }
const _hoisted_4 = {
  key: 0,
  class: "cursor-default"
}
const _hoisted_5 = { class: "items-center flex gap-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus" }, null, -1)
const _hoisted_7 = { class: "hidden lg:block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("chapters.title")), 1),
          (_ctx.role == 'TEACHER' && _ctx.data.adaptive)
            ? _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_4, [
                _createVNode(_component_v_icon, { name: "hi-information-circle" })
              ])), [
                [
                  _directive_tooltip,
                  {
              value: `Clique primeiro em “Adicionar Capítulo”, depois clique em “Adicionar Objetivo” e complete o grafo de conteúdo do curso.`,
              class: 'text-center',
            },
                  void 0,
                  { bottom: true }
                ]
              ])
            : _createCommentVNode("", true)
        ]),
        (_ctx.role == 'TEACHER')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "btn-primary p-button-sm",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToChapter()))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("chapters.add")), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}